import { useState, useEffect, useRef, useMemo } from 'react'
import { SelectedAddOn } from '../../../utility/subscriptionInterfaces'

import { useLocation } from 'react-router-dom'
import { postRequest } from '../../../utility/apiRequest'
import useDropdown from './useDropdown'
import useFetchData from './useFetchData'

const usePlanDetails = () => {
    const [selectedAddOns, setSelectedAddOns] = useState<SelectedAddOn[]>([])
  
   
    const [displayAddOnsOrSummary, setDisplayAddOnsOrSummary] = useState<boolean>(true)
    const [subscriptionResponse, setSubscriptionResponse] = useState<boolean>(false)
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const locationId: string = params.get('locationId') || '';
    const agentCode: string = params.get('agentCode')||'';
    // const status = params.get('status')
    // const [planDetails, setPlanDetails] = useState<PlanDetails[]>([])
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    // const [agentDetails, setAgentDetails] = useState<agentDetails>(intialDetails);

    const { duration, isOpen, dropdownRef,toggleDropdown, handleDurationDropdown } = useDropdown();
    const { planDetails,addOns, agentDetails ,isLoading, isError,balance} = useFetchData(locationId, agentCode);

    const { subtotal, discount, total } = useMemo(() => {
        console.log("i am here 1",duration);
        const basePrice = planDetails.length > 0 ? (duration === 'Yearly' ? planDetails[0].totalAmount : planDetails[0].amountMonth) : 0

        const addOnsTotal = selectedAddOns.reduce((sum, addOn) => sum + addOn.price, 0)
        const calculatedSubtotal = basePrice + addOnsTotal
        const calculatedDiscount = duration === 'Yearly' && planDetails.length > 0 ? (planDetails[0].resellerDiscount / 100) * basePrice : 0
        const calculatedTotal = calculatedSubtotal - calculatedDiscount
        console.log({
            subtotal: calculatedSubtotal,
            discount: calculatedDiscount,
            total: calculatedTotal
        })

        return {
            subtotal: calculatedSubtotal,
            discount: calculatedDiscount,
            total: calculatedTotal
        }
    }, [selectedAddOns,planDetails,duration])

    const handleSelect = (selected: SelectedAddOn) => {
        setSelectedAddOns((prev) => {
            const existingIndex = prev.findIndex((item) => item.id === selected.id)
            if (existingIndex !== -1) {
                return prev.map((item, index) => (index === existingIndex ? selected : item))
            }
            return [...prev, selected]
        })
    }

    const handleRemove = (id: string) => {
        setSelectedAddOns((prev) => prev.filter((item) => item.id !== id))
    }

 

    const toggleDisplayAddOnsOrSummary = () => {
        setDisplayAddOnsOrSummary(!displayAddOnsOrSummary)
    }

   
    // useEffect(() => {
    //     console.log({ subscriptionResponse })
    // }, [subscriptionResponse])


  

    const save = () => {
        const res = postRequest('reseller/subscribe-with-token')
    }
    // console.log({total});

    return {
        handleSelect,
        handleRemove,
        addOns,
        selectedAddOns,
        setSelectedAddOns,
        duration,
        handleDurationDropdown,
        toggleDropdown,
        dropdownRef,
        isOpen,
        displayAddOnsOrSummary,
        toggleDisplayAddOnsOrSummary,
        total,
        subtotal,
        discount,
        balance,
        subscriptionResponse,
        setSubscriptionResponse,
        planDetails,
        locationId,
        agentCode,
        error,
        setError,
        setLoading,
        loading,
        agentDetails
    }
}

export default usePlanDetails
